export class BannerContext {
  public bannerVisible: boolean = true;
  public osInfo: "iOS" | "Android" | "Other" = "Other";
  constructor() {}
}
